/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class SalesNoteProspectLankEnum.
* @enum {}
* @readonly
*/
export default class SalesNoteProspectLankEnum {
    
        /**
         * value: "A"
         * @const
         */
        "A" = "A";

    
        /**
         * value: "B"
         * @const
         */
        "B" = "B";

    
        /**
         * value: "C"
         * @const
         */
        "C" = "C";

    
        /**
         * value: "D"
         * @const
         */
        "D" = "D";

    

    /**
    * Returns a <code>SalesNoteProspectLankEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/SalesNoteProspectLankEnum} The enum <code>SalesNoteProspectLankEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

